import { TitleHeader } from "./TitleHeader";

interface IProps {
  title: string;
  header: string;
  icon?: string;
  text?: string;
  isReversed?: boolean;
}

export const TitleBar = ({ title, header, icon, text, isReversed }: IProps) => {
  return (
    <div>
      <div
        className={`md:flex w-full justify-between md:px-8 gap-8 text-center ${
          isReversed
            ? "md:flex-row-reverse md:text-right"
            : "md:flex-row md:text-left"
        }`}
      >
        <TitleHeader title={title} header={header} />
        {(icon && (
          <img
            className={"hidden md:block md:max-h-24"}
            src={icon}
            alt={"icon"}
          />
        )) ||
          (text && (
            <p
              className={
                "md:w-1/2 md:text-end self-end mt-6 md:mt-0 md:text-2xl text-primary-600"
              }
            >
              {text}
            </p>
          ))}
      </div>
      <hr className={"w-full my-4 border-primary-800"} />
    </div>
  );
};
